module.exports = __webpack_public_path__ + "img/8_60.d29ec97e.png";